var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"png","imageName":"lifeMart","welcomeGroup":"LifeMart members","routePath":"lifemart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }